import { api } from "@/utils/client";
import { keyBy } from 'lodash-es';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        ids: [],
        list: {},
        meta: {},
        selected: undefined,
    },
    getters: {
        orderedList(state) {
            return state.ids.map(id => state.list[id]);
        },
        selected(state) {
            return state.list[state.selected];
        },
        answersByQuestion(state, {selected}) {
            return keyBy(selected?.answers, 'question_id')
        }
    },
    mutations: {
        setList(state, list) {
            state.ids = list.map(({id}) => id)
            state.list = keyBy(list, 'id');
        },
        appendList(state, list) {
            state.ids = [...state.ids, ...list.map(({id}) => id)];
            state.list = {...state.list, ...keyBy(list, 'id')};
        },
        setIds(state, ids) {
            state.ids = ids;
        },
        addItem(state, {id, ...item}) {
            state.ids = [...state.ids, id];
            Vue.set(state.list, id, {id, ...item})
        },
        updateItem(state, {id, ...item}) {
            Vue.set(state.list, id, {id, ...item})
        },
        removeItem(state, id) {
            state.ids = state.ids.filter((_id) => _id !== id);
            Vue.delete(state.list, id)
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
        updateAnswer(state, answer) {
            Vue.set(state.list[state.selected].answers, answer.question_id, answer)
        }
    },
    actions: {
        async getList({commit, state, rootState}, params) {
            const {data: {data, meta}} = await api.get(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/responses`, {
                params: {
                    ...params,
                    deleted: state.showingDeleted ? 1 : 0
                }
            })
            commit(meta.current_page === 1 ? 'setList' : 'appendList', data);
            commit('setMeta', meta);
            return data;
        },
        async getById({commit, rootState, state}, id) {
            const base = rootState.teamId ? `/teams/${rootState.teamId}` : ''
            const {data: {data}} = await api.get(`${base}/surveys/${rootState.surveys.selected}/responses/${id}`,)
            commit('updateItem', data);
            if (id === state.selected) {
                commit('surveyQuestions/setList', data.questions, {root: true})
            }
            return data;
        },
        async create({commit, rootState}, payload) {
            const {data: {data}} = await api.post(`surveys/${rootState.surveys.selected}/responses`, payload)
            commit('addItem', data);
            return data;
        },
        async update({commit, rootState}, {id, ...payload}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/responses/${id}`, payload)
            commit('updateItem', data);
            return data;
        },
        async addNote({commit, rootState}, {id, ...payload}) {
            const {data: {data}} = await api.post(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/responses/${id}/notes`, payload)
            commit('updateItem', data);
            return data;
        },
        async delete({commit, rootState}, id) {
            const {data: {data}} = await api.delete(`teams/${rootState.teamId}/surveys/${rootState.surveys.selected}/responses/${id}`)
            commit('updateItem', data);
            return data;
        },
        async setAnswer({commit, rootState, state}, payload) {
            const url = `surveys/${rootState.surveys.selected}/responses/${state.selected}/answers`;
            const {data: {data}} = await api.post(url, payload)
            commit('updateAnswer', data);
            return data;
        },
        async markComplete({commit, rootState, state, rootGetter}) {
            const {data: {data}} = await api.put(`surveys/${rootState.surveys.selected}/responses/${state.selected}/complete`)
            commit('updateItem', data);
            localStorage.removeItem(`${rootGetter['surveys/selected'].slug}-response-id`);
            return data;
        },
    }

}
